import { MessageCircle, Phone, Navigation } from "lucide-react";
import { SITE, waLink, telLink, WA } from "../config/site";

export const StickyBar = () => (
  <nav
    data-testid="sticky-mobile-bar"
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-charcoal/95 backdrop-blur-xl border-t border-white/10 px-3 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))]"
    aria-label="Quick actions"
  >
    <div className="grid grid-cols-3 gap-2">
      <a
        href={waLink(WA.general)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-mobile-whatsapp-btn"
        className="flex items-center justify-center gap-2 bg-[#25D366] text-charcoal text-sm font-semibold rounded-full py-3 active:scale-95 transition-transform"
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
      <a
        href={telLink}
        data-testid="sticky-mobile-call-btn"
        className="flex items-center justify-center gap-2 bg-gold text-charcoal text-sm font-semibold rounded-full py-3 active:scale-95 transition-transform"
      >
        <Phone size={15} /> Call
      </a>
      <a
        href={SITE.mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-mobile-directions-btn"
        className="flex items-center justify-center gap-2 border border-cream/30 text-cream text-sm font-medium rounded-full py-3 active:scale-95 transition-transform"
      >
        <Navigation size={15} /> Directions
      </a>
    </div>
  </nav>
);
